export enum DocumentState {
    Available = 'available',
    Failed = 'failed',
    Pending = 'pending',
    Warning = 'warning',
}
